"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestAvatar = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../..");
const theme_1 = require("../../../services/theme");
const store_1 = require("../../../store");
const FadeInImage_1 = require("../../Input/components/FadeInImage");
const GuestAvatar = () => {
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    const { guestAvatarUrl } = (0, theme_1.parseTheme)(chatbot);
    return (react_1.default.createElement("div", { className: "w-full h-full rounded-full text-2xl md:text-4xl text-center xs:w-10 xs:h-10" }, guestAvatarUrl &&
        guestAvatarUrl !==
            "https://firebasestorage.googleapis.com/v0/b/typebot.appspot.com/o/userImages%2Fdefault.png?alt=media&token=d0e07116-89f9-41cc-8c66-8ef3b551bce4" ? (react_1.default.createElement(FadeInImage_1.FadeInImage, { className: "rounded-full w-full h-full object-cover", src: (0, __1.parseVariables)(guestAvatarUrl, chatbot.variables) })) : (react_1.default.createElement(__1.DefaultAvatar, { size: "full" }))));
};
exports.GuestAvatar = GuestAvatar;
//# sourceMappingURL=GuestAvatar.js.map